import dayjs from "dayjs";
import { DateRange, DayPicker } from "react-day-picker";
import { useState } from "react";
import isBetween from "dayjs/plugin/isBetween";
import minMax from "dayjs/plugin/minMax";
import "react-day-picker/style.css";

import Modal from "./Modal";
import { classNames } from "../utils";
import snippets from "../i18n/lang";
import { de } from "date-fns/locale";
import { useDateRange } from "../hooks";
dayjs.extend(isBetween);
dayjs.extend(minMax);

export const RangeSelect = () => {
  const { start, end, interval, selectWeek, selectMonth, selectYear, selectCustom } =
    useDateRange();
  const isCurrentWeek = () => interval === "week";
  const isCurrentMonth = () => interval === "month";
  const isCurrentYear = () => interval === "year";

  const classes = (active: boolean) =>
    classNames(
      "text-gray-500 text-xs cursor-pointer",
      active && "bg-primary-500 text-white rounded-full p-1 px-2"
    );

  const [range, setRange] = useState<DateRange | undefined>({
    from: dayjs(start).toDate(),
    to: dayjs(end).toDate(),
  });

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="flex gap-1 items-center">
      <span onClick={selectWeek} className={classes(isCurrentWeek())}>
        {snippets.range.week}
      </span>
      <span onClick={selectMonth} className={classes(isCurrentMonth())}>
        {snippets.range.month}
      </span>
      <span onClick={selectYear} className={classes(isCurrentYear())}>
        {snippets.range.year}
      </span>
      <span
        onClick={() => setModalOpen(true)}
        className={classes(
          !isCurrentMonth() && !isCurrentYear() && !isCurrentWeek()
        )}
      >
        {snippets.range.custom}
      </span>
      <Modal
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        headline={"Eigener Zeitraum"}
      >
        <div className="flex w-full justify-center items-center">
          <DayPicker
            mode="range"
            locale={de}
            startMonth={new Date(2024, 7)}
            endMonth={dayjs().toDate()}
            disabled={{ after: new Date() }}
            selected={range}
            onSelect={(range) => {
              const from = dayjs.min(
                dayjs().subtract(1, "day"),
                dayjs(range.from)
              );
              const to = dayjs.min(dayjs().subtract(1, "day"), dayjs(range.to));
              setRange({ from: from.toDate(), to: to.toDate() });
              selectCustom(range.from, range.to);
            }}
          />
          {/* <DateRange */}
          {/*   editableDateInputs={false} */}
          {/*   rangeColors={["primary"]} */}
          {/*   color={"primary"} */}
          {/*   onChange={(item) => { */}
          {/*     setState([item.selection]); */}
          {/*     selectCustom({ */}
          {/*       startDate: dayjs(item.selection.startDate).format(format), */}
          {/*       endDate: dayjs(item.selection.endDate).format(format), */}
          {/*     }); */}
          {/*   }} */}
          {/*   moveRangeOnFirstSelection={false} */}
          {/*   ranges={state} */}
          {/* /> */}
        </div>
      </Modal>
    </div>
  );
};
